var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellWithDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2332 41.3307C24.5026 41.3026 25.7207 40.8439 26.6722 40.0358C27.6236 39.2276 28.247 38.1221 28.4322 36.9148H17.8328C18.0232 38.1549 18.6758 39.2864 19.6692 40.0987C20.6625 40.911 21.9291 41.3488 23.2332 41.3307Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.265 31.7037L36.9425 31.4313C36.0276 30.6507 35.2268 29.7556 34.5618 28.7701C33.8355 27.41 33.4001 25.9247 33.2813 24.4013V19.9145C33.2775 19.3696 33.2267 18.8258 33.1296 18.2888C31.5229 17.9725 30.0798 17.1344 29.0444 15.9162C28.0091 14.698 27.4452 13.1746 27.4481 11.604V11.0318C26.4578 10.5651 25.3939 10.2582 24.2991 10.1235V8.97913C24.2991 8.65754 24.1657 8.34913 23.9283 8.12174C23.6908 7.89435 23.3687 7.7666 23.0329 7.7666C22.6971 7.7666 22.375 7.89435 22.1375 8.12174C21.9001 8.34913 21.7667 8.65754 21.7667 8.97913V10.1689C19.3155 10.5001 17.0722 11.6692 15.4509 13.4604C13.8296 15.2517 12.9398 17.5441 12.9457 19.9145V24.4013C12.8269 25.9247 12.3916 27.41 11.6653 28.7701C11.0116 29.7531 10.2237 30.6481 9.32249 31.4313L9 31.7037V34.265H37.265V31.7037Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15C37.2091 15 39 13.2091 39 11C39 8.79086 37.2091 7 35 7C32.7909 7 31 8.79086 31 11C31 13.2091 32.7909 15 35 15Z",
    fill: "#FF892A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellWithDot);
export default __webpack_public_path__ + "static/media/bell-with-dot.3f6a22409b870adf8ec3e2420470fa44.svg";
export { ForwardRef as ReactComponent };